import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import routes from './router';
import {library} from '@fortawesome/fontawesome-svg-core'
import {faSort, faSortUp, faSortDown, faAngleRight, faAngleLeft, faPlay, faPause, faSquare, faCircle, faTimes, faLaptop, faTrashAlt, faCopy, faCalendar, faPlusCircle} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VCalendar from 'v-calendar';
import VueLogger from 'vuejs-logger';
import VTooltip from 'v-tooltip'    //https://github.com/Akryum/v-tooltip#usage
// import of dom and watch needs to be enabled to convert <i> fontawesome tags to svg
import {dom} from '@fortawesome/fontawesome-svg-core';
import VueNoty from 'vuejs-noty';
import DotLoader from 'vue-spinner/src/DotLoader.vue';
import Chart from 'chart.js';
import CenterTextPlugin from "./scripts/CenterTextPlugin";
import browserDetect from "vue-browser-detect-plugin";
import store from './store';
import Clipboard from 'v-clipboard';
import moment from 'moment';
Vue.prototype.moment = moment;


Chart.plugins.register(CenterTextPlugin);
dom.watch();

library.add(faSort, faSortUp, faSortDown, faAngleLeft, faAngleRight, faPlay, faPause, faSquare, faCircle, faTimes, faLaptop, faTrashAlt, faCopy, faCalendar, faPlusCircle);
Vue.component('dot-loader', DotLoader);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.config.productionTip = false;
const isProduction = process.env.NODE_ENV === 'production';

const options = {
    isEnabled: true,
    logLevel : isProduction ? 'error' : 'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};

Vue.use(VueLogger, options);
Vue.use(Clipboard);
Vue.use(VueRouter);
Vue.use(VCalendar);
Vue.use(require('vue-moment'));
Vue.use(browserDetect);
Vue.use(VueNoty, {
    timeout: 4000,
    layout: 'bottomRight',
    theme: 'metroui'
});
Vue.use(VTooltip, {
    defaultTrigger: (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) ? 'click' :'hover',
    defaultOffset: 7,
    defaultDelay: 200,
});

Vue.directive('hide-children', {
    bind(el) {
        let icon = document.createElement('span');
        icon.classList.add('accordion-item-trigger-icon', 'is-active');
        el.append(icon);
        el.addEventListener('click', (event) => {
            if (event.target.classList.contains('accordion-item-trigger-icon')) {
                let display = 'block';
                if (event.target.classList.contains('is-active')) {
                    display = 'none';
                    event.target.classList.remove('is-active');
                } else {
                    event.target.classList.add('is-active');
                }
                for (let i = 0; i < el.childNodes.length; i++) {
                    try {
                        if (!el.childNodes[i].classList.contains('accordion-item-trigger-icon')) {
                            el.childNodes[i].style.display = display;
                        }
                    } catch (e) {
                        console.error(e);
                    }
                }
            }
        });
    }
});

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            // here I check that click was outside the el and his children
            if (!(el == event.target || el.contains(event.target))) {
                // and if it did, call method provided in attribute value
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', el.clickOutsideEvent)
    },
});


Vue.config.devtools = true;
const router = new VueRouter({routes});
let app = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

router.beforeEach((to, from, next) => {
    if (to.path === '/campaigns/create') {
        app.$store.commit('campaign/resetCampaign');
    }
    if(from.path !== to.path){
        app.redirectedFrom = from.path;
        next();
    }
});
